
    ;(function(window) {

        'use strict';
        $( document ).ready(function() {
            if (document.querySelector('.grid') !== null) {
                var selectizeCollection = {},
                    grid = document.querySelector('.grid'),
                    $container;
                init();

            };

            function throttle(fn, delay) {
                var allowSample = true;

                return function(e) {
                    if (allowSample) {
                        allowSample = false;
                        setTimeout(function() { allowSample = true; }, delay);
                        fn(e);
                    }
                };
            }

            function init() {
                // preload images
                imagesLoaded(grid, function() {
                    initFlickity();
                    initIsotope();
                    initEvents();
                    $('form[name="catalog"]').trigger('change');
                    classie.remove(grid, 'grid--loading');
                    var sortMatch = window.location.search.match(/sortValue=(.+)&sortOrder=(.+)/);
                    if(sortMatch && sortMatch.length == 3 && sortMatch[1] == 'price') {
                        if(sortMatch[2] == 'asc') {
                            $('.sort-by-button-group button').removeClass('asc').addClass('desc');
                        }
                        else {
                            $('.sort-by-button-group button').removeClass('desc').addClass('asc');
                        }
                        var sortAscending = (sortMatch[2] == 'asc');
                        $container.isotope({ sortBy: sortMatch[1], sortAscending : sortAscending });
                    }
                    $('.lazy').Lazy({
                        afterLoad: function (element) {
                            $(element).parents().removeClass('spinner');
                        },
                        onError: function (element) {
                            $(element).parents().removeClass('spinner');
                        }
                    });
                });
            }

            function initFlickity() {
                $.each($('.slider:not(.flickity-enabled)'), function(key, val) {
                    new Flickity(this, {
                        prevNextButtons: false,
                        wrapAround: true,
                        cellAlign: 'left',
                        contain: true,
                                resize: false,
                                lazyLoad: true
                        });

                        $(this).on('lazyLoad.flickity', function (event, cellElement) {
                            $(cellElement).removeClass('spinner');
                        });
                })
            }

            function initIsotope() {
                $container = $('.grid').isotope({
                  itemSelector: '.grid__item',
                  percentPosition: true,
                  getSortData: {
                    price: '.iso-price parseInt',
                  },
                });
            }


            function initEvents() {
                $container.on( 'click', '.grid__item .remove-item', function( event ) {
                  event.preventDefault();
                  $.get($(event.currentTarget).attr('href'));
                  var target = $(event.currentTarget).parents('.grid__item');
                  $container.isotope( 'remove', target );
                  $container.isotope();
                  if ($container.isotope('getItemElements').length == 0) {
                    location.reload();
                  }
                });

                $('.sort-by-button-group').on( 'click', 'button', function(e) {
                  var sortValue = $(this).attr('data-sort-value');
                  var params = 'sortValue=' + sortValue;

                  if ($(this).hasClass('asc')) {
                    $container.isotope({ sortBy: sortValue, sortAscending : true });
                    params += '&sortOrder=asc';
                    $(this).removeClass('asc').addClass('desc');
                  } else if ($(this).hasClass('desc')) {
                    $container.isotope({ sortBy: sortValue, sortAscending : false });
                    params += '&sortOrder=desc';
                    $(this).removeClass('desc').addClass('asc');
                  }
                  var url = window.location.pathname + '?' + params;
                    window.history.pushState("", "", url);
                });
            }


            $('body').on('change', 'form[name="catalog"]', function(event) {

                event.preventDefault();
                var form = $(this).serialize();
                var elems = $container.isotope('getItemElements');
                var ids = [];
                jQuery.each(elems , function(index, value){
                  ids.push($(value).attr('id'));
                });

                var url = Routing.generate('arberi_category_filter', {'products': ids.join('-'), '_locale' : $('html').attr('lang')});
                $.ajax({
                  url: url,
                  data: form,
                  method: 'POST',
                  success: function(data) {
                        var elems = [];
                            $(data.insert).find('.grid__item').each(function (index, element) {
                            elems.push(element);
                        });
                        $container.prepend( elems );
                        $container.isotope('prepended', elems);
                        $('.lazy').Lazy({
                            afterLoad: function (element) {
                                $(element).parents().removeClass('spinner');
                            },
                            onError: function (element) {
                                $(element).parents().removeClass('spinner');
                            }
                        });

                        initFlickity();


                        $.each(data.remove, function(index, value) {
                          $container.isotope('remove', $('#'+value) );
                        });
                        $container.isotope();


                        $('#total').html(data.total);
                        console.log(data.total);
                        $('[data-toggle="tooltip"]').tooltip();
                  }
                });
            });



            // initialize the selectize control
            var selectCollection = $('.selectize-catalog');
            $.each(selectCollection, function(key, val) {
                var currentSelectize = $(this).selectize({
                    plugins: ['remove_button'],
                });
                selectizeCollection[$(val).data('id')] = currentSelectize;
            });
        });
    })(window);
